import { Component, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import { StepperModule } from 'primeng/stepper';
import { FormsModule } from '@angular/forms';

import { AddressService } from '../../core/services/address/address.service';
import { Address, AddressResponse } from '../../shared/interface/address';

import { ListComponent } from "../../feutures/user-address/list/list.component";
import { AddUpdateComponent } from "../../feutures/user-address/add_update/add-update.component";
import { ConfirmComponent } from "../../shared/components/popapconfirm/confirm.component";
import { MapComponent } from '../../feutures/user-address/map/map.component';
import { StorageService } from '../../auth/storage.service';
import { MessageService } from 'primeng/api';
import { TranslatePipe, TranslateService } from "@ngx-translate/core";
@Component({
  selector: 'app-address',
  standalone: true,
  imports: [
    CommonModule,
    DialogModule,
    ButtonModule,
    StepperModule,
    FormsModule,
    ListComponent,
    AddUpdateComponent,
    ConfirmComponent,
    MapComponent,
    TranslatePipe
   
  ],
  templateUrl: './address.component.html',
  styleUrls: ['./address.component.scss']
})
export class AddressComponent implements OnInit {

  private _addressService = inject(AddressService);
@Output() addressSelected = new EventEmitter<Address>();
  @Input() visible = false;
  @Output() close = new EventEmitter<void>();
  message = inject(MessageService);
translateService = inject(TranslateService);
  // ⭐ الجديد
  onAddressSelected(address: Address) {
    this.addressSelected.emit(address);
    this.close.emit(); 
  }
  onHideDialog() {
    this.close.emit();
  }
 _StorageService = inject(StorageService);
  firstName: string | null = null;
  addresses: Address[] = [];

  view: 'list' | 'stepper' = 'list';
  mode: 'add' | 'edit' = 'add';

  selectedAddress: Address | null = null;

formData: Partial<Address> | null = null;


  showConfirm = false;
  selectedToDelete!: Address;

  ngOnInit() {
    this.firstName = this._StorageService.getItem('firstName');
    this.getAddresses();
  }

  getAddresses() {
    this._addressService.getlogedaddress().subscribe((res: AddressResponse) => {
      this.addresses = res.addresses;
    });
  }

selectedLat!: string;
selectedLong!: string;

onLocationChange(event: { lat: string; long: string }) {
  this.selectedLat = event.lat;
  this.selectedLong = event.long;

  console.log('Saved Location:', this.selectedLat, this.selectedLong);
}

  openAdd() {
    this.mode = 'add';
    this.formData = null;
    this.selectedLat = undefined!;
    this.selectedLong = undefined!;
    this.view = 'stepper';
  }

 openEdit(address: Address) {
  this.mode = 'edit';
  this.selectedAddress = address;

  this.formData = {
    city: address.city,
    street: address.street,
    phone: address.phone
  };

  this.selectedLat = address.lat!;
  this.selectedLong = address.long!;

  this.view = 'stepper';
}

  resetToList() {
    this.view = 'list';
    this.selectedAddress = null;
    this.getAddresses();
  }

 
  onFormSubmit(data: Partial<Address>) {
    this.formData = data;
  }

 submitAddress() {
  const payload = {
    ...this.formData,
    lat: this.selectedLat,     
    long: this.selectedLong  ,
        username: this.firstName || 'defaultUser'  
  };

  if (this.mode === 'add') {
    this._addressService.addaddress(payload).subscribe(() => {
    this.message.add({severity:'success', summary:'Success', detail:'address added successfully'})
      this.resetToList();
    });
  } else if (this.selectedAddress?._id) { 
    
    this._addressService
      .updateaddress(payload, this.selectedAddress._id)
      .subscribe(() => {
        this.message.add({severity:'success', summary:'Success', detail:'address updated successfully'})
        this.resetToList();
      });
  }
}



  onDelete(address: Address) {
    this.selectedToDelete = address;
    this.showConfirm = true;
  }

  confirmDelete() {
    this._addressService
      .removeaddress(this.selectedToDelete._id!)
      .subscribe(() => {
         this.message.add({severity:'success', summary:'Success', detail:'address deleted successfully'})
        this.showConfirm = false;
        this.getAddresses();
      });
  }
}
